(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function(){
  var header = document.querySelector('.header-sticky-stack');
  var mainHeader = document.querySelector('.main-header-bar-wrapper');
  var topBar = document.querySelector('.header-top-bar');
  if(!header) return;

  var mql = window.matchMedia('(min-width: 750px)');
  var scrollListenerAttached = false;

  function setVars(){
    requestAnimationFrame(function(){
      var mainHeaderH = (mainHeader ? mainHeader.offsetHeight : (header ? header.offsetHeight : 0));
      var topBarVisible = !!topBar && !topBar.classList.contains('is-hidden') && topBar.offsetParent !== null;
      var topBarH = topBarVisible ? topBar.offsetHeight : 0;
      var totalH = mainHeaderH + topBarH;

      document.documentElement.style.setProperty('--main-header-h', mainHeaderH + 'px');
      document.documentElement.style.setProperty('--mobile-header-h', totalH + 'px');
    });
  }

  function getThreshold(){
    // Start fixing as soon as we scroll past the top bar height
    return topBar ? topBar.offsetHeight : 0;
  }

  function onScroll(){
    // Only act on desktop
    if (!mql.matches) return;
    var shouldStick = window.scrollY >= getThreshold();
    var isSticky = header.classList.contains('is-sticky');

    if (shouldStick && !isSticky) {
      header.classList.add('is-sticky');
      if (topBar) topBar.classList.add('is-hidden');
      requestAnimationFrame(setVars);
    } else if (!shouldStick && isSticky) {
      header.classList.remove('is-sticky');
      if (topBar) topBar.classList.remove('is-hidden');
      requestAnimationFrame(setVars);
    }
  }

  function enableDesktop(){
    setVars();
    if (topBar) {
      if (window.scrollY >= getThreshold()) topBar.classList.add('is-hidden');
      else topBar.classList.remove('is-hidden');
    }
    onScroll();
    if (!scrollListenerAttached) {
      window.addEventListener('scroll', onScroll, { passive: true });
      scrollListenerAttached = true;
    }
  }

  function disableMobile(){
    header.classList.remove('is-sticky');
    if (topBar) topBar.classList.remove('is-hidden');
    document.documentElement.style.setProperty('--main-header-h', (mainHeader ? mainHeader.offsetHeight : header.offsetHeight) + 'px');
    document.documentElement.style.setProperty('--mobile-header-h', (mainHeader ? mainHeader.offsetHeight : header.offsetHeight) + 'px');
    if (scrollListenerAttached) {
      window.removeEventListener('scroll', onScroll, { passive: true });
      scrollListenerAttached = false;
    }
  }

  // Initial mode
  if (mql.matches) {
    enableDesktop();
  } else {
    disableMobile();
  }

  // Recalculate on resize/orientation and switch modes across the breakpoint
  function handleResize(){
    if (mql.matches) {
      enableDesktop();
    } else {
      disableMobile();
    }
  }

  // Recalculate if header or top bar resize (e.g. logo loads, announcement bar wraps)
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(function(){ setVars(); });
    if (mainHeader) ro.observe(mainHeader);
    if (topBar) ro.observe(topBar);
  }

  mql.addEventListener('change', handleResize);
  window.addEventListener('resize', handleResize);
  window.addEventListener('orientationchange', handleResize);

  // Recalculate when the logo image finishes loading
  var logoImg = mainHeader ? mainHeader.querySelector('.header__heading-logo') : null;
  if (logoImg && !logoImg.complete) {
    logoImg.addEventListener('load', function(){ handleResize(); }, { once: true });
  }
});

  } catch(e) { console.error(e); }
})();
})();
